import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InHomeCareComponent } from './in-home-care/in-home-care.component';
import { HemoTechComponent } from './hemo-tech/hemo-tech.component';
import { AuthGuard } from '@shared/auth/auth-guard';
import { HospitalComponent } from './hospital/hospital.component';

const routes: Routes = [
  {
    path: 'in-home-care',
    canActivate: [ AuthGuard ],
    component: InHomeCareComponent
  },
  {
    path: 'hemo-tech',
    canActivate: [ AuthGuard ],
    component: HemoTechComponent
  },
  {
    path: 'hospital',
    canActivate: [ AuthGuard ],
    canDeactivate: [(component: HospitalComponent) => component.canLeave()],
    component: HospitalComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicenseRoutingModule { }
